import { render } from "./ContactStepIntro.vue?vue&type=template&id=6886b0f5"
import script from "./ContactStepIntro.vue?vue&type=script&lang=js"
export * from "./ContactStepIntro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__